var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenclawBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1px",
    height: "1px",
    viewBox: "0 0 1 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "openclaw-color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-16.6614007%",
    y1: "-10.000474%",
    x2: "-16.6614007%",
    y2: "-10.000474%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-16.6614007%",
    y1: "-3.47323545%",
    x2: "129.110058%",
    y2: "91.1308211%",
    id: "linearGradient-2",
    offset: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-16.6614007%",
    y1: "48.0439812%",
    x2: "129.110058%",
    y2: "51.5045407%",
    id: "linearGradient-3",
    offset: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "n8n-and-Openclaw",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "openclaw-color",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.648615588,0.299325198 C0.638134127,0.309119824 0.631875,0.322985851 0.631875,0.337875 L0.684625,0.390625 C0.705960383,0.390625 0.725194948,0.377772875 0.733359645,0.358061551 C0.735034481,0.35401814 0.736175851,0.349849443 0.736801919,0.345646782 C0.744598174,0.326825534 0.740320449,0.305319957 0.726020758,0.291020267 C0.711721067,0.276720576 0.69021549,0.27244285 0.671532044,0.280181787 C0.661910356,0.284167221 0.654012929,0.290935392 0.648615588,0.299325198 Z M0.5,0.0653333333 C0.76375,0.0653333333 0.895625,0.285125 0.895625,0.460958333 C0.895625,0.636791667 0.76375,0.812583333 0.631875,0.856541667 L0.631875,0.944458333 L0.543958333,0.944458333 L0.543958333,0.856541667 C0.5,0.874125 0.456041667,0.856541667 0.456041667,0.856541667 L0.456041667,0.944458333 L0.368125,0.944458333 L0.368125,0.856541667 C0.23625,0.812625 0.104375,0.636791667 0.104375,0.460958333 C0.104375,0.285125 0.23625,0.0653333333 0.5,0.0653333333 Z M0.376916667,0.326375089 L0.426915936,0.376374358 C0.447138753,0.376374358 0.465370301,0.364192427 0.473109237,0.345508981 C0.480848174,0.326825534 0.476570449,0.305319957 0.462270758,0.291020267 C0.447971067,0.276720576 0.42646549,0.27244285 0.407782044,0.280181787 C0.389098598,0.287920724 0.376916667,0.306152272 0.376916667,0.326375089 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.148333333,0.373041667 C0.0165,0.329083333 -0.0275,0.417 0.0165,0.504916667 C0.0604583333,0.592833333 0.148333333,0.548875 0.192333333,0.460958333 C0.218666667,0.399416667 0.192333333,0.373041667 0.148333333,0.373041667 L0.148333333,0.373041667 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.851666667,0.373041667 C0.9835,0.329083333 1.0275,0.417 0.9835,0.504916667 C0.939541667,0.592833333 0.851666667,0.548875 0.807666667,0.460958333 C0.781333333,0.399416667 0.807666667,0.373041667 0.851666667,0.373041667 L0.851666667,0.373041667 Z",
    id: "Path",
    fill: "url(#linearGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.229458333,0.039630085 C0.249291667,0.0230212621 0.272625,0.0260516438 0.29675,0.0417863181 C0.320791667,0.0575209925 0.347708333,0.0868923846 0.377458333,0.128501857 C0.372318268,0.121309274 0.372319617,0.109650916 0.377461348,0.102460662 C0.382603078,0.0952704074 0.390938588,0.0952704074 0.396080319,0.102460662 C0.40122205,0.109650916 0.401223399,0.121309274 0.396083333,0.128501857 C0.367208333,0.0881161926 0.342791667,0.0621831182 0.322875,0.0491874428 C0.303083333,0.0362500438 0.28975,0.0372407456 0.280291667,0.0451663593 C0.283654945,0.0529175739 0.282499179,0.0629368824 0.277563653,0.0688154402 C0.272628128,0.0746939979 0.265371872,0.0746939979 0.260436347,0.0688154402 C0.255500821,0.0629368824 0.254345055,0.0529175739 0.257708333,0.0451663593 L0.229458333,0.039630085 Z M0.703208333,0.0380416667 C0.727375,0.0267916667 0.750708333,0.0245833333 0.770541667,0.0364583333 C0.767178388,0.0309163588 0.768334154,0.0237527393 0.77326968,0.0195496796 C0.778205206,0.01534662 0.785461461,0.01534662 0.790396987,0.0195496796 C0.795332512,0.0237527393 0.796488278,0.0309163588 0.793125,0.0364583333 C0.783666667,0.0307916667 0.770333333,0.0300833333 0.750541667,0.0393333333 C0.730625,0.048625 0.706208333,0.0671666667 0.677375,0.0960416667 C0.682515066,0.10118423 0.682513716,0.109519739 0.677371986,0.114660638 C0.672230255,0.119801536 0.663894745,0.119801536 0.658753014,0.114660638 C0.653611284,0.109519739 0.653609934,0.10118423 0.65875,0.0960416667 C0.6885,0.0662916667 0.715416667,0.0452916667 0.739416667,0.0340833333 L0.703208333,0.0380416667 Z",
    id: "Shape",
    fill: "url(#linearGradient-3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenclawBlack);
export default __webpack_public_path__ + "static/media/openclaw-black.fdd320af913fa438c4af97a0d195feaf.svg";
export { ForwardRef as ReactComponent };